import { IssueEntity } from 'types/IssueEntity'

/**
 * Om aktien bytt namn i instrument_history efter publiceringsdatum skiljer sig
 * nameAtPublication från currentName. Då ska namnet vid emissionen visas.
 */
export function getShareNameAtPublicationHint(issue: IssueEntity): string | null {
    const meta = issue.shareNameMetadata
    if (!meta?.nameAtPublication || meta.currentName == null) return null
    if (meta.currentName === meta.nameAtPublication) return null

    const atPub = meta.nameAtPublication

    if (issue.type === 'IPO') {
        return `Vid tidpunkten för börsintroduktionen hette aktien ${atPub}.`
    }

    return `Vid tidpunkten för emissionen hette aktien ${atPub}.`
}
